import { useEffect } from "react";

import { useHistory } from "react-router";

import { useGetIsSubscribedToMarketData } from "~/v2/api/hooks";
import { Path } from "~/v2/path";
import { MarketDataLoadingPres } from "./MarketDataLoading.pres";

export const MarketDataConnector = () => {
  const history = useHistory();

  const { isLoading, isSubscribed } = useGetIsSubscribedToMarketData();

  // Redirect to Market Data Subscribe flow if not subscribed
  // or Overview page if subscribed or was previously subscribed
  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (!isSubscribed) {
      history.push(Path.ROUTE_MARKET_DATA_SUBSCRIBE);
    } else {
      history.push(Path.ROUTE_MARKET_DATA_OVERVIEW);
    }
  }, [isLoading, isSubscribed, history.push]);

  return <MarketDataLoadingPres />;
};
